// Success message
export const toastMessages = {
  LOGIN_SUCCESSFUL: {
    message: "Logged in successfully",
    type: "success",
  },
  SIGNUP_SUCCESSFUL: {
    message: "Sign Up successful",
    type: "success",
  },
  LOGOUT_SUCCESSFUL: {
    message: "Logout Successful",
    type: "success",
  },
  PASSWORD_UPDATED: {
    message: "Password is Updated",
    type: "success",
  },
  OTP_VERIFIED: {
    message: "Otp is verified",
    type: "success",
  },
  OTP_VERIFICATION_ALREADY_SENT: {
    message: "Otp sent already please check your mail",
    type: "info",
  },
  OTP_VERIFICATION_REQUIRED: {
    message: "Otp sent to mail",
    type: "info",
  },
  INVALID_CREDENTIALS: {
    message: "Credentials is invalid",
    type: "error",
  },
  USER_ALREADY_EXISTS: {
    message: "User already exist",
    type: "error",
  },
  EMAIL_NOT_FOUND: {
    message: "Email not found",
    type: "error",
  },
  INVALID_PASSWORD: {
    message: "Please Check your credentials",
    type: "error",
  },
  INVALID_PASSWORD_SIGNUP: {
    message:
      "password must contain atleast 8 characters ( 1 uppercase and lower case alphabet ,1 number and 1 symbol )",
    type: "info",
  },
  INVALID_EMAIL: {
    message: "Invalid email please enter valid email",
    type: "error",
  },
  INVALID_NAME: {
    message: "Name is invalid",
    type: "warning",
  },
  PASSWORD_NOT_MATCH: {
    message: "Password does not match",
    type: "warning",
  },
  NO_USER_FOUND: {
    message: "No user is found please sign up",
    type: "info",
  },
  CANNOT_USE_LAST_3_PASSWORDS: {
    message: "Cannot use same password again",
    type: "warning",
  },
  INVALID_OTP: {
    message: "Invalid OTP",
    type: "error",
  },
  MAX_OTP_RETRIES_EXCEEDED: {
    message:
      "Reached maximum otp verification attempts. please try some other time",
    type: "error",
  },
  BAD_REQUEST: {
    message: "Bad Request",
    type: "error",
  },
  ACCESS_EXPIRED: {
    message: "Session Expired, Please Sign In again.",
    type: "error",
  },
  DEFAULT: {
    message: "Something went wrong",
    type: "error",
  },
  UNAUTHORIZED: {
    message: "User Unauthorized",
    type: "error",
  },
  ACCESS_EXPIRED: {
    message: "Access Expired",
    type: "error",
  },
};
